import { PageCriteria } from '../../../shared/model/local/pagination/page-criteria';
import { MessageThreadStatus } from './message-thread-status';

export class MessageThreadCriteria extends PageCriteria {
  status?: MessageThreadStatus;
  /** ISO date string (URL/API). Form uses Date; emit with startOfDay/endOfDay toISOString(). */
  dateFrom?: string;
  dateTo?: string;

  constructor() {
    super();
  }
}
